export enum TestType {
  FLASH = 'FLASH',
  TEST = 'TEST',
  LEARN = 'LEARN'
}
